import { InjectionToken } from '@angular/core';

export const QUESTIONNAIRE_TENANT_OVERRIDE = new InjectionToken<string | null>(
  'QUESTIONNAIRE_TENANT_OVERRIDE'
);

export const QUESTIONNAIRE_ROUTE_PREFIX = new InjectionToken<string | null>(
  'QUESTIONNAIRE_ROUTE_PREFIX'
);

export const QUESTIONNAIRE_LOCALE_PATH_INDEX = new InjectionToken<number>(
  'QUESTIONNAIRE_LOCALE_PATH_INDEX'
);
